import React from 'react';

interface Props {
  text?: string;
}

const Loading: React.FC<Props> = ({ text }) => {
  return (
    <>
      <div className="flex-cloumn flex  min-h-[40px] w-full items-center justify-center">
        <div className="loading-container contents animate-pulse space-x-5">
          <div className="loading-bar"></div>
          <div className="loading-bar"></div>
          <div className="loading-bar"></div>
          <div className="loading-bar"></div>
          <div className="loading-bar"></div>
        </div>
      </div>
      <div className="mt-4 block text-center text-xs font-light">{text ? text : 'Loading'}</div>
    </>
  );
};

export default Loading;
